import React, { useCallback, useEffect, useRef, useState } from "react";
import { Box } from "@material-ui/core";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import {
  CustomBadge,
  CustomBreadCrumb,
  PageTitle,
  CustomButton,
  CustomTabs,
  CustomMenu,
} from "../../../../Components";
import {
  useIsDesktop,
  useQuery,
  useSelectedTheme,
  useTitle,
  useTranslate,
} from "../../../../Hooks";
import { useVerticalNav } from "../../../../Contexts/VerticalNavContext";
import {
  GetAllPropertyImagesCategoryByPropertyId,
  GetAllPropertyVideosCategoryByPropertyId,
  PropertiesAdvanceSearchTest,
} from "../../../../Services";
import {
  FinanceCompany, // 1
  Gallery, // 2
  Marketing, // 3
  MPI, // 4
  PropertyInfo, // 5
  Specifications, // 6
  UnitModels, // 7
  DocumentTab, // 8
  PaymentPlan, // 9
  Units, // 10
  Task, // 11
  Nearby, // 12
  AgentCourseQualifications, // 13
} from "./UI";
import {
  AddNewPropertyImageDialog,
  AddNewPropertyVideoDialog,
} from "./UI/Gallery/UI";
import CustomHistoryTabsComponent from "../../../../Components/V2/CustomHistoryComponent/CustomHistoryComponentTabs";
import { useSelector } from "react-redux";

// icons
import {
  ChevronDown,
  ClockIcon,
  EditIcon,
  EyeIcon,
  PlusIcon,
  ShareIcon05,
} from "../../../../assets/icons";

// styles
import useStyles from "./styles";

function PropertyOverview() {
  const styles = useStyles();

  const { translate } = useTranslate("NewPropertiesView");

  const {
    theme: { palette },
  } = useSelectedTheme();

  const history = useHistory();

  const { isDesktop } = useIsDesktop();
  const activeItem = useSelector((state) => state.ActiveItemReducer);

  const { isExpanded, setActionableItems } = useVerticalNav();
  const query = useQuery();
  const addUnitmodelRef = useRef();
  const upladDocRef = useRef();
  const addGallery = useRef();
  const addFinancePlanRef = useRef();
  const addPaymentPlanRef = useRef();
  const propretyId = query.get("id");
  const formTypeId = query.get("formType");
  useTitle(translate("property-over-View"));
  const [tabValue, setTabValue] = useState(0);
  const [isHistoryOpen, setIsOpenHistoryOpen] = useState(false);
  const [isPropertyManagementView, setIsPropertyManagementView] =
    useState(false);
  const [isLoadingPropertiesDetailes, setIsLoadingPropertiesDetailes] =
    useState(false);
  const [propretyResponse, setPropretyResponse] = useState([]);
  const [activePropertyData, setActivePropertyData] = useState();
  const [uploadType, setUploadType] = useState(null); // 'images' or 'videos'
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState(false);
  const [allPropertyImages, setAllPropertyImages] = useState([]);
  const [allPropertyVideo, setAllPropertyVideo] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refetchDataPropertyImage, setRefetchDataPropertyImage] =
    useState(false);
  const [refetchDataPropertyVideo, setRefetchDataPropertyVideo] =
    useState(false);

  const handleAddNewGallery = (type) => {
    setUploadType(type);
    setIsUploadDialogOpen(true);
  };

  const GetAllPropertyImages = useCallback(async () => {
    setIsLoading(true);
    const response = await GetAllPropertyImagesCategoryByPropertyId(propretyId);
    setAllPropertyImages(response);
    setIsLoading(false);
  }, [propretyId]);

  const getAllPropertyVideosCategoryByPropertyId = useCallback(
    async (propertyId) => {
      setIsLoading(true);
      const result = await GetAllPropertyVideosCategoryByPropertyId(propertyId);
      if (!(result && result.status && result.status !== 200)) {
        setAllPropertyVideo(result || []);
      } else setAllPropertyVideo([]);
      setIsLoading(false);
    },
    []
  );

  const propretyOverviewTabs = [
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Property-Info"),
      component: (
        <PropertyInfo
          setTabValue={setTabValue}
          propretyId={propretyId}
          propretyResponseJson={activePropertyData}
          propretyResponse={propretyResponse}
          isLoadingPropertiesDetailes={isLoadingPropertiesDetailes}
        />
      ),
      actionButton: {
        label: translate("Edit"),
        handler: () => {
          history.push(
            `/home/Properties-CRM/edit?formType=${formTypeId}&id=${propretyId}`
          );
        },
        startIcon: (
          <EditIcon width="20" height="20" fill={palette.button.primary_fg} />
        ),
      },
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Unit-Models"),
      component: <UnitModels propretyId={propretyId} ref={addUnitmodelRef} />,
      actionButton: {
        label: translate("Add-new-unit-model"),
        handler: () => {
          if (addUnitmodelRef.current) {
            addUnitmodelRef.current.addUnitModelHandler();
          }
        },
        startIcon: (
          <PlusIcon width="20" height="20" fill={palette.button.primary_fg} />
        ),
      },
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Units"),
      component: <Units propretyId={propretyId} />,
      actionButton: null,
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Finance-Company"),
      component: (
        <FinanceCompany propretyId={propretyId} ref={addFinancePlanRef} />
      ),
      actionButton: {
        label: translate("add-new-finance-plan"),
        handler: () => {
          if (addFinancePlanRef.current) {
            addFinancePlanRef.current.addFinancePlanModelHandler();
          }
        },
        startIcon: (
          <PlusIcon width="20" height="20" fill={palette.button.primary_fg} />
        ),
      },
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Marketing"),
      component: (
        <Marketing
          propretyId={propretyId}
          testImages={propretyResponse[0]?.propertyImages}
        />
      ),
      actionButton: {
        customComponent: (
          <Box display="flex" style={{ gap: "12px" }}>
            <CustomButton
              boxShadow="xs"
              size="lg"
              variant="outlined"
              color="secondary"
              onClick={() => {}}
              startIcon={
                <ShareIcon05
                  width="20"
                  height="20"
                  fill={palette.button.secondaryColor_fg}
                />
              }
              style={{
                borderColor: palette.button.secondaryColor_border,
                color: palette.button.secondaryColor_fg,
              }}
            >
              {translate("publish-on-website")}
            </CustomButton>
            <CustomButton
              boxShadow="xs"
              size="lg"
              variant="outlined"
              color="secondary"
              onClick={() => {}}
              startIcon={
                <EyeIcon
                  width="20"
                  height="20"
                  fill={palette.button.secondary_fg}
                />
              }
            >
              {translate("preview")}
            </CustomButton>
            <CustomButton
              boxShadow="xs"
              size="lg"
              variant="outlined"
              color="primary"
              onClick={() => {}}
              startIcon={
                <EditIcon
                  width="20"
                  height="20"
                  fill={palette.button.primary_fg}
                />
              }
            >
              {translate("Edit")}
            </CustomButton>
          </Box>
        ),
      },
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Specifications"),
      component: <Specifications propretyId={propretyId} />,
      actionButton: null,
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("MPI"),
      component: <MPI propretyId={propretyId} />,
      actionButton: null,
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Documents"),
      component: <DocumentTab propertyId={propretyId} ref={upladDocRef} />,
      actionButton: {
        label: translate("Upload-docoument"),
        handler: () => {
          if (upladDocRef.current) {
            upladDocRef.current.uploadDocHandler();
          }
        },
        startIcon: (
          <PlusIcon width="20" height="20" fill={palette.button.primary_fg} />
        ),
      },
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Payment-Plan"),
      component: (
        <PaymentPlan propretyId={propretyId} ref={addPaymentPlanRef} />
      ),
      actionButton: {
        label: translate("add-custom-payment-plan"),
        handler: () => {
          if (addPaymentPlanRef.current) {
            addPaymentPlanRef.current.addPaymentPlanHandler();
          }
        },
        startIcon: (
          <PlusIcon width="20" height="20" fill={palette.button.primary_fg} />
        ),
      },
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Gallery"),
      component: (
        <Gallery
          propretyId={propretyId}
          ref={addGallery}
          allPropertyImages={allPropertyImages}
          allPropertyVideo={allPropertyVideo}
          isLoading={isLoading}
          setRefetchDataPropertyImage={setRefetchDataPropertyImage}
          setRefetchDataPropertyVideo={setRefetchDataPropertyVideo}
        />
      ),
      actionButton: {
        label: null,
        handler: null,
        startIcon: null,
        endIcon: null,
        customComponent: (
          <CustomMenu
            menuItems={[
              {
                text: translate("Property-images"),
                handler: () => handleAddNewGallery("images"),
              },
              {
                text: translate("Property-videos"),
                handler: () => handleAddNewGallery("videos"),
              },
            ]}
            activeIconClass={styles.menuActiveIconClass}
            defaultIconClass={styles.menuDefaultIconClass}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              padding="10px 16px"
              border={`1px solid ${palette.button.primary_bg}`}
              bgcolor={palette.background.brand_solid}
              borderRadius="8px"
              sx={{ cursor: "pointer", boxShadow: 1 }}
              color={palette.button.primary_fg}
            >
              <PlusIcon
                width="20"
                height="20"
                fill={palette.button.primary_fg}
              />
              <Box
                component="span"
                mx={1}
                className={styles.titleCustomComponent}
              >
                {translate("add-new")}
              </Box>
              <ChevronDown
                width="20"
                height="20"
                fill={palette.button.primary_fg}
              />
            </Box>
          </CustomMenu>
        ),
      },
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Task"),
      component: <Task propretyId={propretyId} />,
      actionButton: null,
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Nearby"),
      component: <Nearby propretyId={propretyId} />,
      actionButton: null,
    },
    {
      title: activePropertyData?.property?.property_name || "",
      subTitle: translate("View-your-Properties-details"),
      label: translate("Agent-Course-Qualifications"),
      component: <AgentCourseQualifications propretyId={propretyId} />,
      actionButton: null,
    },
  ];

  const userHasPolicyToDisplayData = useCallback(async (propertyId) => {
    setIsLoadingPropertiesDetailes(true);
    const isForLog = true;

    const body = {
      criteria: {
        Ids: [{ searchType: 1, value: propertyId }],
      },
      filterBy: "createdOn",
      orderBy: 2,
    };

    const res = await PropertiesAdvanceSearchTest(
      { pageIndex: 0, pageSize: 2, isForLog },
      body
    );
    if (!(res && res.status && res.status !== 200)) {
      if (res && res.totalCount > 0) {
        if (
          res &&
          res.result &&
          res.result.length &&
          res.result[0].propertyJson
        ) {
          const propertyJson = JSON.parse(
            res && res.result && res.result.length && res.result[0].propertyJson
          );
          setPropretyResponse(res?.result);
          setActivePropertyData(propertyJson);
        }
      } else {
        setActivePropertyData(null);
        setPropretyResponse([]);
      }
    } else {
      setActivePropertyData(null);
    }

    setIsLoadingPropertiesDetailes(false);
  });

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    setActionableItems({
      selectedIds: [],
      action: null,
    });
  };

  useEffect(() => {
    userHasPolicyToDisplayData(propretyId);
  }, []);

  useEffect(() => {
    GetAllPropertyImages();
    setRefetchDataPropertyImage(false);
  }, [refetchDataPropertyImage]);

  useEffect(() => {
    getAllPropertyVideosCategoryByPropertyId(propretyId);
    setRefetchDataPropertyVideo(false);
  }, [refetchDataPropertyVideo]);

  return (
    <>
      <CustomBreadCrumb
        breadcrumbs={[
          { label: translate("crm"), nonClickable: true },
          {
            label: translate("Properties"),
            link: "/home/Properties-CRM/view",
          },
        ]}
        containerClasses={styles.breadCrumbContainer}
      >
        <CustomBadge
          Style={{
            padding: "4px 8px",
            borderRadius: "6px",
            lineHeight: "20px",
          }}
          label={`${activePropertyData?.property?.property_name || ""}`}
          BackgroundColor={palette.breadcrumbs.brand_bg_hover}
          BorderColor={palette.breadcrumbs.brand_bg_hover}
          Color={palette.breadcrumbs.brand_fg_hover}
        />
      </CustomBreadCrumb>
      <PageTitle
        title={propretyOverviewTabs[tabValue].title}
        subTitle={propretyOverviewTabs[tabValue].subTitle}
        hideDivider
        showBackIcon
      >
        {propretyOverviewTabs[tabValue].actionButton?.customComponent ? (
          propretyOverviewTabs[tabValue].actionButton.customComponent
        ) : propretyOverviewTabs[tabValue].actionButton ? (
          <CustomButton
            boxShadow="xs"
            size="lg"
            variant="outlined"
            color="primary"
            onClick={propretyOverviewTabs[tabValue].actionButton.handler}
            startIcon={
              propretyOverviewTabs[tabValue].actionButton.startIcon ?? null
            }
            endIcon={
              propretyOverviewTabs[tabValue].actionButton.endIcon ?? null
            }
          >
            {propretyOverviewTabs[tabValue].actionButton.label}
          </CustomButton>
        ) : null}
      </PageTitle>

      <Box className={styles.historyPercentage}>
        <CustomButton
          boxShadow="none"
          variant="text"
          size="md"
          color="tertiary"
          onClick={() => {
            setIsOpenHistoryOpen(true);
          }}
          startIcon={
            <ClockIcon
              width="20"
              height="20"
              fill={palette.button.tertiary_fg}
            />
          }
        >
          {translate("history")}
        </CustomButton>
        {activePropertyData?.property?.data_completed !== null && (
          <CustomBadge
            label={activePropertyData?.property?.data_completed + "%" || "0%"}
            SizeVariant={"small"}
            BackgroundColor={
              palette.utility[
                activePropertyData?.property?.data_completed >= 50
                  ? "brand_50"
                  : "error_50"
              ]
            }
            BorderColor={
              palette.utility[
                activePropertyData?.property?.data_completed >= 50
                  ? "brand_200"
                  : "error_200"
              ]
            }
            Color={
              palette.utility[
                activePropertyData?.property?.data_completed >= 50
                  ? "brand_700"
                  : "error_700"
              ]
            }
          />
        )}
      </Box>
      <Box
        className={clsx(styles.overviewWrapper, {
          [styles.overviewWrapperExpanded]: isExpanded && isDesktop,
        })}
      >
        <Box
          className={clsx(styles.tabsSide, {
            [styles.tabsSideExpanded]: isExpanded && isDesktop,
          })}
        >
          <CustomTabs
            tabValue={tabValue}
            onTabChange={handleTabChange}
            tabs={propretyOverviewTabs}
            variant="overview"
          />
        </Box>
        <CustomHistoryTabsComponent
          activeItem={activeItem}
          isOpen={isHistoryOpen}
          isOpenChanged={() => setIsOpenHistoryOpen(false)}
          formType={formTypeId}
          typeId={"property"}
          isPropertyManagementView={isPropertyManagementView}
        />
      </Box>

      {uploadType === "videos" && isUploadDialogOpen && (
        <AddNewPropertyVideoDialog
          onOpen={isUploadDialogOpen}
          onClose={() => {
            setIsUploadDialogOpen(false);
          }}
          propretyId={propretyId}
          setRefetchDataPropertyVideo={setRefetchDataPropertyVideo}
        />
      )}

      {uploadType === "images" && isUploadDialogOpen && (
        <AddNewPropertyImageDialog
          onOpen={isUploadDialogOpen}
          onClose={() => {
            setIsUploadDialogOpen(false);
          }}
          propretyId={propretyId}
          setRefetchDataPropertyImage={setRefetchDataPropertyImage}
        />
      )}
    </>
  );
}

export default PropertyOverview;
